import { Form, Button, Input, TimePicker, Checkbox } from "antd";

import FormButtonsWrap from "../form-buttons-wrap/form-buttons-wrap.component";
import { WEEKDAYS_REF } from "../../utils/dataUtils";

const initialValues = {
  id: "",
  description: "",
  startTime: "",
  endTime: "",
  weekDays: [],
};

/**
 * Formulario que realiza registro de nuevo horario
 */
const ScheduleFrom = ({ onFinish }) => {
  const [form] = Form.useForm();

  const localOnFinish = (values) => {
    onFinish(values);
    form.resetFields();
  };

  return (
    <div>
      <Form form={form} initialValues={initialValues} onFinish={localOnFinish}>
        <Form.Item type="text" name="id" style={{ display: "none" }}>
          <Input maxLength={11} />
        </Form.Item>
        <Form.Item label="Descripción" name="description" required>
          <Input type="text" maxLength={100} required />
        </Form.Item>
        <Form.Item label="Hora inicio (24hrs)" name="startTime" required>
          <TimePicker format="HH:mm:ss" required />
        </Form.Item>
        <Form.Item label="Hora fin (24hrs)" name="endTime" required>
          <TimePicker required />
        </Form.Item>
        <Form.Item label="Días de la semana" name="weekDays" required>
          <Checkbox.Group>
            {WEEKDAYS_REF.map((weekDay) => (
              <Checkbox key={weekDay.value} value={weekDay.value}>
                {weekDay.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </Form.Item>
        <FormButtonsWrap>
          <Button type="primary" htmlType="submit">
            Guardar
          </Button>
          <Button
            onClick={() => {
              form.resetFields();
            }}
          >
            Limpiar
          </Button>
        </FormButtonsWrap>
      </Form>
    </div>
  );
};

export default ScheduleFrom;
